import { Chip } from '@side/pantry';

export function InactiveChip() {
  return <Chip size="small" label="Inactive" variant="outlined" />;
}
